/**
 * Dostepne numery identyfikacji podatkowej merchanta p24
 */
export const P24MerchantTaxIdentification = {

    PESEL: {
        id: 1,
        name: 'PESEL',
        displayText: 'Osoba fizyczna',
        isNipRequired: false,
        isPeselRequired: true,
        isP24MerchantIdRequired: false
    },
    NIP: {
        id: 2,
        name: 'NIP',
        displayText: 'Działalność gospodarcza / Spółka / Stowarzyszenie',
        isNipRequired: true,
        isPeselRequired: false,
        isP24MerchantIdRequired: false
    },
    P24_MERCHANT_ID: {
        id: 3,
        name: 'P24_MERCHANT_ID',
        displayText: 'Identyfikator Merchanta P24',
        isNipRequired: false,
        isPeselRequired: false,
        isP24MerchantIdRequired: true
    },
}

/**
 * Kolekcja typow
 */
export const P24MerchantTaxIdentificationList = Object.keys(P24MerchantTaxIdentification).map(type => P24MerchantTaxIdentification[type])

/**
 * Metoda zwracająca typ działalności bazując na identyfikatorze
 * 
 * @param {int} id identyfikator typu działalności
 * 
 * @returns {P24MerchantTaxIdentification} typ działalności
 */
export const getP24MerchantTaxIdentificationById = (id) => {
    if (!id) {
        return P24MerchantTaxIdentification._1;
    }

    // szukamy pierwszego elementu, który spełnia warunki dla podanych parametrów wejściowych  
    let type = P24MerchantTaxIdentificationList.find(item => item.id === id)
    return type;
}

/**
 * Metoda zwracająca typ działalności bazując na nazwie
 * 
 * @param {String} name nazwa typu działalności
 * 
 * @returns {P24MerchantTaxIdentification} typ działalności
 */
export const getP24MerchantTaxIdentificationByName = (name) => {
    if (!name) {
        return P24MerchantTaxIdentification._1;
    }

    // szukamy pierwszego elementu, który spełnia warunki dla podanych parametrów wejściowych  
    let type = P24MerchantTaxIdentificationList.find(item => item.name === name)
    return type;
}